<nav
  class="navbar navbar-expand-lg bg-white shadow-sm py-3 fixed-top"
  role="navigation"
  aria-label="Navegação principal"
>
  <div class="container">
    <a
      class="navbar-brand d-flex align-items-center fw-bold"
      href="#inicio"
      style="color: var(--bs-primary)"
      (click)="scrollToSection('inicio'); $event.preventDefault()"
    >
      <img
        src="assets/image/favicon.svg"
        alt="Logo Sismet"
        width="32"
        height="32"
        class="me-2"
        loading="eager"
      />
      Sismet - Web
    </a>

    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarWeather"
      aria-controls="navbarWeather"
      aria-expanded="false"
      aria-label="Abrir menu de navegação"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div
      class="collapse navbar-collapse justify-content-end"
      id="navbarWeather"
    >
      <ul class="navbar-nav">
        <li class="nav-item">
          <a
            href="#inicio"
            class="nav-link fw-semibold"
            [class.active]="activeSection === 'inicio'"
            (click)="scrollToSection('inicio'); $event.preventDefault()"
            >Início</a
          >
        </li>
        <li class="nav-item">
          <a
            href="#weather-conditions"
            class="nav-link fw-semibold"
            [class.active]="activeSection === 'weather-conditions'"
            (click)="
              scrollToSection('weather-conditions'); $event.preventDefault()
            "
            >Clima</a
          >
        </li>
        <!-- <li class="nav-item">
          <a
            href="#mapa"
            class="nav-link fw-semibold"
            [class.active]="activeSection === 'mapa'"
            (click)="scrollToSection('mapa'); $event.preventDefault()"
            >Mapa Climático</a
          >
        </li> -->
        <li class="nav-item">
          <a
            href="#news"
            class="nav-link fw-semibold"
            [class.active]="activeSection === 'news'"
            (click)="scrollToSection('news'); $event.preventDefault()"
            >Notícias</a
          >
        </li>
        <!-- <li class="nav-item">
          <a
            href="#cotacao"
            class="nav-link fw-semibold"
            [class.active]="activeSection === 'cotacao'"
            (click)="scrollToSection('cotacao'); $event.preventDefault()"
            >Cotação</a
          >
        </li> -->
        <li class="nav-item">
          <a
            href="#about"
            class="nav-link fw-semibold"
            [class.active]="activeSection === 'about'"
            (click)="scrollToSection('about'); $event.preventDefault()"
            >Sobre</a
          >
        </li>
      </ul>
    </div>
  </div>
</nav>
